import React from "react"

import {
    TabContext,
    TabPanel,
} from "@mui/lab"
import {
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from "@mui/material"

import { t } from "@lingui/macro"

import {
    SbTab,
    SbTabList,
} from "components/commons"
import {
    BrandPriority,
    PaginatedResponse,
} from "models"

import { ResearchCard } from "../research-card"


interface ResearchColumnOneProps {
    researchData: PaginatedResponse<BrandPriority>
    selectedResearchId: string
    handleRowClick: (index: number) => void
    handleClone: (index: number) => void
    handleOpenEdit: () => void
    handleOpenDelete: () => void
}
interface ResearchColumnOneState {

}
export class ResearchColumnOne extends React.Component<ResearchColumnOneProps, ResearchColumnOneState> {
    render() {
        return (
            <TabContext value={"1"}>
                <Box sx={{ borderBottom: 0 }}>
                    <SbTabList variant="fullWidth">
                        <SbTab
                            disableRipple
                            disableTouchRipple
                            label={t({ id: "research.my-opening", message: "Le mie aperture", })}
                            value="1" />
                    </SbTabList>
                </Box>
                <TabPanel value="1" sx={{ px: 0, height: "63vh", overflow: "auto" }}>
                    <List disablePadding sx={{ margin: 0 }}>
                        {
                            this.props.researchData &&
                            this.props.researchData.items.map((data: BrandPriority, index: number) => (
                                <ListItem key={index} onClick={() => this.props.handleRowClick(index)} sx={{ padding: 0, marginY: 0 }}>
                                    <ListItemButton sx={{ padding: 0, margin: 0 }}>
                                        <ListItemText sx={{ margin: 0 }}>
                                            <ResearchCard
                                                data={data}
                                                selectedResearchId={this.props.selectedResearchId}
                                                handleClone={() => this.props.handleClone(index)}
                                                handleEdit={this.props.handleOpenEdit}
                                                handleDelete={this.props.handleOpenDelete}
                                            />
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            ))}
                    </List>
                </TabPanel>
            </TabContext>
        )
    }
}
